var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 225 225",
    style: {
      enableBackground: "new 0 0 225 225"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#006CB8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cak-logo",
    transform: "translate(-38 239.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45524",
    className: "st0",
    d: "M98-225.6c1.8,2.4,16.7,24.1,33.3,48.1c16.5,24.1,30.4,43.7,30.8,43.7 c0.8,0,53.7-74.7,53.1-75c-0.5-0.4-28.2-5.2-29.9-5.2c-0.9,0-5.9,5.8-11.9,14c-5.8,7.7-10.6,14-10.8,14s-5.8-8.2-12.5-18.2 s-12.4-18.2-12.8-18.2c-0.8,0-37.7-6.4-40.3-7.1C94.8-230.1,94.9-229.9,98-225.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45525",
    d: "M67.9-179.8v25.3l17.7,15.4l17.7,15.5l-17.5,14.7L68.4-94.1l-0.3,25.9l-0.2,25.9l8.4-7.7 c32.3-30.1,77.3-73.4,77.2-74.3c-0.2-0.8-72.1-69-83.5-79.1l-2.1-1.8V-179.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45526",
    d: "M201.4-155c-17.2,16.5-31.3,30.4-31.3,31c0,0.5,14.2,14.5,31.5,31.1l31.5,30.1V-101l-10.8-11.4 c-9.4-9.9-10.6-11.5-9.6-12.9c0.7-0.8,5.5-6,10.8-11.4l9.6-9.9l-0.2-19.2l-0.3-19.2L201.4-155z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45527",
    className: "st0",
    d: "M130-68.4c-17.5,25.3-32.5,47-33.4,48.4L95-17.5l17.9-3.1c9.9-1.8,19.5-3.5,21.3-3.7 c3.1-0.5,4-1.7,15.4-19.1c6.7-10.2,12.3-18.6,12.6-18.6c0.3,0,5.1,6.2,10.7,13.7c5.5,7.7,10.4,14.2,10.8,14.7 c0.6,0.7,27-3.3,31.4-4.6c1-0.4-51.1-75.2-52.8-75.9C161.9-114.1,147.3-93.6,130-68.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0eb2e4f1216dbdc91731aab301dc2126.svg";
export { ForwardRef as ReactComponent };